
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from 'recharts';

export const ResponseRateChart: React.FC = () => {
  // Mock data - would be replaced with actual API data
  const data = [
    { name: 'Ene', tasa: 65 },
    { name: 'Feb', tasa: 59 },
    { name: 'Mar', tasa: 80 },
    { name: 'Abr', tasa: 81 },
    { name: 'May', tasa: 56 },
    { name: 'Jun', tasa: 55 },
    { name: 'Jul', tasa: 72 },
    { name: 'Ago', tasa: 78 },
  ];

  const config = {
    tasa: {
      label: 'Tasa de Respuesta',
      color: '#82ca9d',
    }
  };

  return (
    <Card className="col-span-1">
      <CardHeader>
        <CardTitle>Tasa de Respuesta de Establecimientos</CardTitle>
      </CardHeader>
      <CardContent className="pt-4">
        <ChartContainer className="aspect-video h-64" config={config}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart
              data={data}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis domain={[0, 100]} label={{ value: '%', position: 'insideLeft', angle: -90 }} />
              <ChartTooltip
                content={<ChartTooltipContent />}
              />
              <Line 
                type="monotone" 
                dataKey="tasa" 
                stroke="#82ca9d" 
                strokeWidth={2}
                dot={{ r: 4 }}
                activeDot={{ r: 6 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </ChartContainer>
      </CardContent>
    </Card>
  );
};
